import { Query } from 'src/core/stores/data-store';
import FormStoreMock from './base/form-store';
import DataStoreMock from './base/data-store';
import { CreateDefaultRoleItem, DefaultRoleItem, DefaultRoleSummary } from 'src/stores/default-roles-store';
import { DefaultRoleMockData } from '../data-sources/default-role-summary';
import { UpdateRoleItem } from 'src/stores/roles-store';

export class DefaultRoleSummaryStoreMock extends DataStoreMock<DefaultRoleSummary> {
  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: DefaultRoleMockData,
      count: DefaultRoleMockData.length,
    });
    return true;
  }
}

export class DefaultRoleItemStoreMock extends FormStoreMock<DefaultRoleItem, CreateDefaultRoleItem> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/default-roles`);
  }

  public async loadRole() {
    return DefaultRoleMockData[0];
  }

  public async update(id: string, item: UpdateRoleItem) {
    return { isSuccess: true };
  }

  public async loadPermissions(id: string) {
    return await this.handleCallAsync(async () => {
      this._state.set((s) => {
        s.item = DefaultRoleMockData[0] as DefaultRoleItem;
        return s;
      });
      return DefaultRoleMockData[0] as DefaultRoleItem;
    });
  }

  rolePermissionsBasePath = 'permissions';

  public async addRolePermissions(id: string, permissionIds: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async deleteRolePermissions(id: string, permissionIds: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }
}
